export { cn } from '@kent/shared';

/**
 * Convert empty strings to undefined. Useful for converting filter values to API params.
 */
export function emptyToUndefined(value: string): string | undefined {
  return value || undefined;
}
